<template>
  <div class="modal">
    <div class="bg" @click="closeAlert"></div>
    <div class="container">
      <div class="top">
        <p class="emoji" v-if="config.emoji !== ''">{{ config.emoji }}</p>
        <p class="title" v-if="config.title !== ''" v-html="config.title"></p>
        <p
          class="content"
          v-if="config.content !== ''"
          v-html="config.content"
        ></p>
      </div>
      <div class="bottom" @click="closeAlert">
        확인
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonEmojiAlert',
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          emoji: '',
          title: '',
          content: ''
        }
      }
    }
  },
  methods: {
    closeAlert() {
      this.$emit('close-alert')
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/_index.scss';
.modal {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  display: block;
  .bg {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
  .container {
    width: 300px;
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    border-radius: 24px;
    .top {
      position: relative;
      padding: 0 24px;
      .emoji {
        font-size: 80px;
        display: inline-block;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -55px);
      }
      .title {
        font-size: 24px;
        font-weight: $bold;
        padding-top: 57px;
        margin-bottom: 10px;
        text-align: center;
      }
      .content {
        font-size: 14px;
        font-weight: $light;
        padding-bottom: 24px;
        text-align: center;
        &::v-deep {
          a {
            text-decoration: underline;
            font-weight: $bold;
          }
        }
      }
    }
    .bottom {
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-top: 1px solid #e1e1e1;
      cursor: pointer;
      font-weight: $medium;
    }
  }
}
</style>
